// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"6454":"Widgets","6821":"plone-volto-components-theme-InjectPloneComponentsCSS-InjectPloneComponentsCSS","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] + "." + {"6454":"114d15e2","6821":"f8869ce2","7051":"114d15e2"}[chunkId] + ".chunk.css";
};